import { render, staticRenderFns } from "./boat-type.vue?vue&type=template&id=2e992084&scoped=true"
import script from "./boat-type.vue?vue&type=script&lang=js"
export * from "./boat-type.vue?vue&type=script&lang=js"
import style0 from "./boat-type.vue?vue&type=style&index=0&id=2e992084&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e992084",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {VImg: require('/var/www/tubber-new/components/global/v/img.vue').default,RequestAction: require('/var/www/tubber-new/components/global/RequestAction.vue').default})
